import { useField, useFormikContext } from 'formik';

/**
 * The validation message to show for a field, following grow-ui's form
 * wrapper: nothing until the field is touched or the form submitted, and an
 * explicit `override` (a caption such as "Select a state first") replaces the
 * Formik error whenever it is passed.
 */
const useFieldMessage = (name: string, override?: string | null) => {
  const [, { error, touched }] = useField(name);
  const { submitCount } = useFormikContext();
  const hasError = Boolean((touched || submitCount) && error);
  if (override !== undefined) {
    return { hasError, message: override };
  }
  return { hasError, message: hasError ? error ?? null : null };
};

export default useFieldMessage;
